export const homePath = '/';
